import { ServiceLockResults } from '@common/data-models/service/service-lock-results';

export class ServiceMoveRecord {
    public LockResults?: ServiceLockResults;
    public NewPath?: string;
    public ROSequence?: any;
}